<template>
    <details class="filter-block" :open="isOpen">
        <summary class="filter-block__head">
            <span>
                <label v-bind="isLabel ? { for: searchInputId } : {}">
                    <strong class="h3">{{ name }}</strong>
                </label>

                <span class="filter-block__icon"></span>
            </span>
        </summary>
        <div>
            <slot name="header" />
            <div
                ref="scrollable"
                class="filter-block__list"
                :class="{ 'has-scroll': scrollable }"
            >
                <slot />
            </div>
            <slot name="footer"></slot>
        </div>
    </details>
</template>
<script>
export default {
    name: 'FilterListBlock',
    components: {},
    props: {
        name: {
            type: String,
            default: ''
        },
        searchInputId: {
            type: String,
            default: ''
        },
        isOpen: {
            type: Boolean,
            default: true
        },
        isLabel: {
            type: Boolean,
            default: true
        },
        scrollable: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss">
.filter-block {
    $b: &;

    &[open] {
        #{$b}__icon {
            background-image: $icon-filter-close;
        }

        #{$b}__head {
            margin-bottom: 2rem;
        }
    }

    &__head {
        cursor: pointer;

        > span {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .h3 {
            font-size: 16px;
            flex: 1 0 50%;

            @media #{$media-md-up} {
                margin: 0 0 0 0.6rem;
            }
        }

        &::-webkit-details-marker {
            display: none;
        }
    }

    &__icon {
        width: 22px;
        height: 23px;
        background-image: $icon-filter-open;
    }

    &__list {
        margin: 2rem 0;

        &.has-scroll {
            @media #{$media-md-up} {
                position: relative;
                max-height: 30.4rem;
                overflow: auto;

                scrollbar-color: $sherpa-blue transparent;
                scrollbar-width: thin;

                &::-webkit-scrollbar {
                    width: 4px;
                    height: 8px;
                    background-color: $gray-lighter4;
                }

                &::-webkit-scrollbar-thumb {
                    width: 4px;
                    background: $sherpa-blue;
                    border-radius: $border-radius-small;
                }
            }
        }
    }
}
</style>
